module.exports = __webpack_public_path__ + "static/media/Cultuzz.7fc48158.ico";